import React from "react";
import { Link } from "react-router-dom";

// Reusable Sidebar Link Component
const SidebarLink = ({ to, icon, label, extraClass = "" }) => (
  <li className={`nav-item ${extraClass}`}>
    <Link className="nav-link collapsed" to={to}>
      <i className={icon}></i>
      <span>{label}</span>
    </Link>
  </li>
);

// Reusable Sidebar Dropdown Component
const SidebarDropdown = ({ label, icon, target, children }) => (
  <li className="nav-item">
    <a
      className="nav-link collapsed"
      data-bs-target={target}
      data-bs-toggle="collapse"
      href="#"
      aria-expanded={false}
      aria-controls={target.slice(1)} // Extracting the ID from the target
    >
      <i className={icon}></i>
      <span>{label}</span>
      <i className="bi bi-chevron-down ms-auto"></i>
    </a>
    <ul
      id={target.slice(1)}
      className="nav-content collapse"
      data-bs-parent="#sidebar-nav"
    >
      {children}
    </ul>
  </li>
);

const Sidebar = ({ isOpen }) => {
  return (
    <React.Fragment>
      <aside id="sidebar" className={`sidebar ${isOpen ? "active" : ""}`}>
        <ul className="sidebar-nav" id="sidebar-nav">
          {/* Dashboard Link */}
          <SidebarLink to="/dashboard" icon="bi bi-house-door text-primary" label="Dashboard" />
          <SidebarLink to="/dashboard/client" icon="bi bi-person-lines-fill text-primary" label="Clients" />
          <SidebarLink to="/dashboard/project" icon="bi bi-briefcase text-primary" label="Projects" />
          <SidebarLink to="/dashboard/ledger" icon="bi bi-book text-primary" label="Ledger" />
          <SidebarLink to="/dashboard/ledger-due" icon="bi bi-currency-rupee text-primary" label="Ledger Due" />
          {/* Employee Section */}
          <SidebarLink to="/dashboard/report" icon="bi bi-book text-primary" label="report" />
          <SidebarLink to="/dashboard/website" icon="bi bi-globe text-primary" label="Website" />


          {/* Leave Section */}
         

          {/* Project Section */}
          

         

          {/* Other Links */}
          <li className="nav-heading">Others</li>
       
          <SidebarLink to="/" icon="bi bi-box-arrow-in-right" label="Log-Out" />
        </ul>
      </aside>
    </React.Fragment>
  );
};

export default Sidebar;
